import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Accordion } from 'us-react-components/dist/Accordion/Accordion';
import { Link } from '../../components';

const accordionClasses = 'pb-3';
const headerTextClasses = 'text-base';

export const PayoutFaq = (): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);

  return (
    <>
      <h3 className='text-2xl font-semibold'>{t('pages.sitter.payout.faqHeading')}</h3>
      <Accordion headerTextClasses={headerTextClasses} headerText={t('pages.sitter.payout.faqWhyHeader')}>
        <div className={accordionClasses}>
          {t('pages.sitter.payout.faqWhyDescription1Branch')}
          <br /> <br />
          {t('pages.sitter.payout.faqWhyDescription2Branch')}{' '}
          <Link
            className='text-sapphire mt-3'
            to={t('pages.sitter.payout.faqWhyDescriptionLinkUri')}
            title={t('pages.sitter.payout.branchSupport')}
            newTab
            external
          >
            {t('pages.sitter.payout.faqWhyDescriptionLinkText')}
          </Link>
        </div>
      </Accordion>
      <Accordion headerTextClasses={headerTextClasses} headerText={t('pages.sitter.payout.faqHowLongHeader')}>
        <div className={accordionClasses}>
          {t('pages.sitter.payout.faqHowLongDescriptionBranch')}
        </div>
      </Accordion>
      <Accordion headerTextClasses={headerTextClasses} headerText={t('pages.sitter.payout.faqFeesHeader')}>
        <div className={accordionClasses}>
          {t('pages.sitter.payout.faqFeesDescriptionBranch')}
        </div>
      </Accordion>
      <Accordion headerTextClasses={headerTextClasses} headerText={t('pages.sitter.payout.faqDebitCardHeaderBranch')}>
        <div className={accordionClasses}>
          {t('pages.sitter.payout.faqDebitCardDescription1Branch')}
          <br /> <br />
          {t('pages.sitter.payout.faqDebitCardDescription2Branch')}
        </div>
      </Accordion>
      <Accordion headerTextClasses={headerTextClasses} headerText={t('pages.sitter.payout.faqTransferHeader')}>
        <div className={accordionClasses}>
          {t('pages.sitter.payout.faqTransferDescriptionBranch')}
        </div>
      </Accordion>
      <div className='mt-3'>
        <Link
          className='text-sapphire font-bold'
          to={t('pages.sitter.payout.branchUri')}
          title={t('pages.sitter.payout.learnMore')}
          newTab
          external
        >
          {t('pages.sitter.payout.learnMore')}
        </Link>
      </div>
    </>
  );
};
